<template>
  <a-tooltip overlayClassName="mpd-tooltip" :getPopupContainer="getPopupContainer" v-bind="$attrs">
    <slot></slot>
  </a-tooltip>
</template>

<script>
export default {
  name: 'MpdTooltip',
  inject: ['mpdContainer'],
  methods: {
    getPopupContainer() {
      return this.mpdContainer()
    }
  }
}
</script>

<style lang="less">
.mpd-tooltip {
  .ant-tooltip-inner {
    font-size: 12px;
    min-height: auto;
  }
}
</style>
